import apiClient from 'api';
import { fetchAllFromMonitorServer } from 'api/common';
import { filterForAllowedProperties } from 'utils/format';

const monitorApiBaseUrl = window.env.REACT_APP_MONITOR_API_PATH;
const northgateApiBaseUrl = window.env.REACT_APP_NORTHGATE_API_PATH;

export const allowedCurvesProperties = [
  'curveDataArray',
  'curveId',
  'curveType',
  'xMultiplier',
  'yMultiplier',
  'yRefType',
  'localCurve'
];

export const fetchAllCurves = async (queryParams = {}) => {
  const curves = await fetchAllFromMonitorServer(
    'curve',
    ['start', 'limit'],
    queryParams
  );
  return curves.map(curve =>
    filterForAllowedProperties(curve, allowedCurvesProperties)
  );
};

export const fetchCurveById = async curveId => {
  return await apiClient.get(monitorApiBaseUrl, `/curve/${curveId}`);
};

export const create = async curve => {
  return await apiClient.post(northgateApiBaseUrl, `/curve`, curve);
};

export const remove = async curveId => {
  return await apiClient.delete(northgateApiBaseUrl, `/curve/${curveId}`);
};
